import { createAction, props } from "@ngrx/store";
import { LmsTab } from "./lms.reducer";

export const setSaveLms = createAction(
  '[Lms] Set save header',
  props<{ onSave: boolean, tab: LmsTab}>()
);
